<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">

        <div
          style="padding-left: 10px;padding-right: 10px;padding-top: 20px;padding-bottom: 10px; display: flex;justify-content: flex-end;align-items: center;">
          <div style="color:red;font-size:16px;margin-right: 40px;">请尽量用手机端微信，功能更好用更完整！</div>
          <el-tooltip class="item" effect="dark" content="手上已经有表格,制表有点麻烦,直接导入吧" placement="bottom">
            <el-button type="primary" @click="makeFormList()">制作打分表</el-button>
          </el-tooltip>

          <el-tooltip class="item" effect="dark" content="告诉您下一步怎么操作" placement="bottom">
            <el-button type="danger" @click="whatIsNextStep()">打分表制作好后下一步怎么让让大家领取和填写？</el-button>
          </el-tooltip>

        </div>
        <div style="padding-left: 10px;padding-right: 10px;">
          <el-table border :data="tableData" stripe style="width: 100%;"
            :header-cell-style="{background:'#eef1f6',color:'#606266'}">
            <el-table-column type="index" label="序号" width="50" header-align="center" align="center">
            </el-table-column>
            <el-table-column label="打分表名称">
              <template slot-scope="scope">
                <span style="font-weight: bold;">
                  <div>
                    {{scope.row.form_name}}
                  </div>
                </span>
              </template>

            </el-table-column>

            <el-table-column label="ID" width="80" align="center">
              <template slot-scope="scope">
                <span style="">
                  <div>
                    {{scope.row.id}}
                  </div>
                </span>
              </template>

            </el-table-column>

            <el-table-column label="类型" width="120">
              <template slot-scope="scope">

                <div v-if="scope.row.form_type=='10'">
                  简易自评表
                </div>
                <div v-else-if="scope.row.form_type=='20'">
                  简易互评表
                </div>
                <div v-else-if="scope.row.form_type=='50'">
                  高级自评表
                </div>
                <div v-else-if="scope.row.form_type=='60'">
                  高级互评表
                </div>
                <div v-else-if="scope.row.form_type=='100'">
                  开放式单人表
                </div>
                <div v-else-if="scope.row.form_type=='110'">
                  开放式多人表
                </div>
              </template>
            </el-table-column>

            <el-table-column label="状态" width="80">
              <template slot-scope="scope">
                <div v-if="scope.row.form_state==0">
                  未发放
                </div>
                <div v-else-if="scope.row.form_state==1">
                  填写中
                </div>
                <div v-else-if="scope.row.form_state==100">
                  已收回
                </div>
              </template>
            </el-table-column>

            <el-table-column label="打分人数" width="80" align="center">
              <template slot-scope="scope">
                <span>
                  {{scope.row.score_user_count}}
                </span>
              </template>
            </el-table-column>

            <el-table-column label="完成率" width="80" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.form_type=='100'">
                  N/A
                </span>
                <span v-else>
                  {{((scope.row.score_user_finished_count/scope.row.score_user_count)*100).toFixed(1)}}%
                </span>
              </template>
            </el-table-column>

            <el-table-column label="打分说明" width="100" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.form_comment">
                  已设置
                </span>
                <span v-else>
                  未设置
                </span>
              </template>
            </el-table-column>



            <el-table-column label="咨询电话" width="120" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.contact_phone">
                  {{scope.row.contact_phone}}
                </span>
                <span v-else>
                  未设置
                </span>
              </template>
            </el-table-column>



            <el-table-column prop="create_time" label="创建时间" align="center" width="180">

            </el-table-column>

            <el-table-column label="操作" header-align="center" align="center" width="120">
              <template slot-scope="scope">
                <div class="actionStyle">


                  <div>
                    <el-button @click.native.prevent="sendForm(scope.$index, tableData)" type="text" size="small">
                      <div>发放打分表</div>
                    </el-button>
                  </div>

                  <div>
                    <el-button @click.native.prevent="editScoreFormName(scope.$index, tableData)" type="text"
                      size="small">
                      修改名称
                    </el-button>
                  </div>


                  <div>
                    <el-button @click.native.prevent="deleteScoreForm(scope.$index, tableData)" type="text"
                      size="small">
                      删除打分表
                    </el-button>
                  </div>


                  <div>
                    <el-button @click.native.prevent="editFormComment(scope.$index, tableData)" type="text"
                      size="small">
                      <span v-if="scope.row.form_comment">
                        修改打分说明
                      </span>
                      <span v-else>
                        添加打分说明
                      </span>
                    </el-button>
                  </div>


                  <div>
                    <el-button @click.native.prevent="editContactPhone(scope.$index, tableData)" type="text"
                      size="small">
                      <span v-if="scope.row.contact_phone">
                        修改咨询电话
                      </span>
                      <span v-else>
                        添加咨询电话
                      </span>
                    </el-button>
                  </div>

                  <div>
                    <el-button @click.native.prevent="manageUser(scope.$index, tableData)" type="text" size="small">
                      <span>
                        人员及指标管理
                      </span>
                    </el-button>
                  </div>

                  <div>
                    <el-button @click.native.prevent="exportData(scope.$index, tableData)" type="text" size="small">
                      导出打分结果
                    </el-button>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>

    <el-dialog title="重要提示" :visible.sync="dialogVisible" width="30%">
      <span>{{msg}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="delFormContentRecord">删 除</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <!--导出选项-->
    <el-dialog title="导出核对表" :visible.sync="exportExcelDialogVisible" :close-on-click-modal="false" width="40%">
      <div>
        <div>将考核结果导出Excel文件.</div>
        <div style="margin-top: 10px;margin-left: 20px;">

        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="exportDataAction">立即导出</el-button>
        <el-button @click="exportExcelDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <!--Excel文件下载-->
    <el-dialog :close-on-click-modal="false" v-dialogDrag title="导出Excel文件成功"
      :visible.sync="downloadExcelDialogVisible">
      <el-form>
        <div>
          <div>
            Excel文件已经生成,请点下面的链接下载。
          </div>
          <div style="margin-top: 20px;"><a target="_blank" :href="current_download_file_name">点我下载导出的excel文件</a></div>
        </div>

      </el-form>
      <div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="copyDownloadUrl">复制下载网址</el-button>
        <el-button type="primary" @click="downloadExcel">下载文件</el-button>
        <el-button @click="downloadExcelDialogVisible=false">关 闭</el-button>
      </div>
    </el-dialog>



    <!--发放表格窗口-->
    <el-dialog :close-on-click-modal="false" v-dialogDrag title="发布查询" :visible.sync="sendFormDialogVisible">
      <el-form>
        <div>
          <div style="font-size: 18px;font-weight: bold;margin-bottom: 5px;">方法一、转发二维码</div>
          <div>在二维码上右键“<span
              style="font-weight: bold;color:red;">图片另存为...</span>”下载此查询的二维码,打印张贴或者在微信中转发二维码,查询人扫码查询.手机端在发布查询时可以直接转发二维码.
          </div>
          <div>
            <div style="display: flex;justify-content: center;"><img :src="qrcode_filename"
                style="width: 200px;height: 200px;" /></div>
          </div>
        </div>
        <div>
          <div style="font-size: 18px;font-weight: bold;margin-bottom: 5px;">方法二、转发小程序</div>
          <div>
            <div>在手机<span style="color:red;">打分测评小程序</span>中点开这个打分表,再点击“发放打分表”转发到微信群或给需要打分的人即可.</div>
          </div>
        </div>

      </el-form>
      <div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="sendFormDialogVisible=false" type="primary">关 闭</el-button>
      </div>
    </el-dialog>

    <el-dialog title="打分表做好了,怎么让大家领表填写？" :visible.sync="howToNextStepDialogVisible" width="50%">
      <div>
        <div>
          <div>
            <div style="margin-bottom: 5px;">操作步骤：</div>
            <div style="margin-bottom: 5px;">1.扫下面的二维码打开“打分测评”小程序；</div>
            <div style="margin-bottom: 5px;">2.在“我发放的”栏目中找到刚发布的打分表；</div>
            <div style="margin-bottom: 5px;">3.点“发放打分表”转发小程序或下载打分表二维码让大家扫码填表.</div>
            <div style="font-size: 16px;margin-top: 10px;margin-bottom: 20px;text-align: center;">
              <div style="font-weight: bold;color:red;margin-bottom: 10px;">微信扫码打开打分测评小程序</div>
              <div><img src="/evaluations/images/dfcp_qrcode.jpg" style="width: 200px;height: 200px;" /></div>
            </div>
          </div>
        </div>

      </div>
      <div style="display: flex;justify-content: flex-end;margin-top: 20px;">
        <el-button @click="howToNextStepDialogVisible = false" type="primary">知道了</el-button>
      </div>

    </el-dialog>

    <el-dialog title="怎么让别人看到我发的表格？" :visible.sync="howToUseInviteFormDialogVisible" width="50%">
      <div>
        <div>
          <div>
            1.打开您刚才扫码登录的小程序；<br />
            2.在手机小程序上点开您想让他看到的表格;<br />
            3.点击“邀请围观”把他邀请进来；<br />
            4.他用小程序扫web网站上的登录二维码登录网页端就可以看到表格了。<br />
          </div>
        </div>

      </div>
      <div style="display: flex;justify-content: flex-end;margin-top: 20px;">
        <el-button @click="howToUseInviteFormDialogVisible = false" type="primary">知道了</el-button>
      </div>

    </el-dialog>



    <!--修改打分表名称-->
    <el-dialog title="修改打分表名称" :close-on-click-modal="false" :visible.sync="editFormNameDialogVisible" width="40%">
      <div>
        <div style="margin-top: 10px;">表格名称:<span style="font-size: 18px;"><input v-model="edit_form_name_content"
              placeholder="点这里输入表格名称" style="font-size:18px;width: 80%;" /></span></div>

      </div>

      <div style="display: flex;justify-content: flex-end;margin-top: 20px;">
        <el-button @click="editFormNameSave" type="primary">保存</el-button>
        <el-button @click="editFormNameDialogVisible = false">取消</el-button>
      </div>

    </el-dialog>


    <!--修改联系电话-->
    <el-dialog title="打分问题咨询电话" :close-on-click-modal="false" :visible.sync="editContactPhoneDialogVisible" width="40%">
      <div>
        <div style="margin-top: 10px;">咨询电话:<span style="font-size: 18px;"><input v-model="edit_contact_phone"
              placeholder="点这里输入咨询电话" style="font-size:18px;width: 80%;" /></span></div>

      </div>

      <div style="display: flex;justify-content: flex-end;margin-top: 20px;">
        <el-button @click="editContactPhoneSave" type="primary">保存</el-button>
        <el-button @click="editContactPhoneDialogVisible = false">取消</el-button>
      </div>

    </el-dialog>


    <!--修改打分表说明-->
    <el-dialog title="打分说明及注意事项" :close-on-click-modal="false" :visible.sync="editFormCommentDialogVisible" width="40%">
      <div>
        <div style="margin-top: 10px;">
          <textarea style="width:99%;" v-model="edit_form_comment" placeholder="点这里输入打分说明及注意事项" maxlength="-1"
            rows="8"> </textarea>
        </div>
      </div>

      <div style="display: flex;justify-content: flex-end;margin-top: 20px;">
        <el-button @click="editFormCommentSave" type="primary">保存</el-button>
        <el-button @click="editFormCommentDialogVisible = false">取消</el-button>
      </div>

    </el-dialog>


  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  import '../assets/global.css'

  import Utils from '../utils/utils.js'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {
        edit_form_name_content: '',
        editFormNameDialogVisible: false,


        edit_contact_phone: '',
        editContactPhoneDialogVisible: false,

        edit_form_comment: '',
        editFormCommentDialogVisible: false,


        username: '',
        tableData: [],
        dialogVisible: false,
        searchResultSettingDialogTableVisible: false,
        position: -1,
        msg: '',
        configurations: [],
        showPosition: false,
        unReadDialogFormVisible: false,

        shownotify: 0,
        successDialogVisible: false,

        downloadExcelDialogVisible: false,
        downloadZipDialogVisible: false,
        sendFormDialogVisible: false,

        current_download_file_name: '',
        selected_form_id: '',
        selected_form_name: '',
        selected_form: '',

        downloadPDFDialogVisible: false,
        howToNextStepDialogVisible: false,

        zip_file_form_id: '',

        howToUseInviteFormDialogVisible: false,
        deleteFormConfirmDialogVisible: false,

        random_num: '',
        tmp_random_num: '',

        current_packed_time: '',
        downloadExistZipDialogVisible: false,

        current_index: '',
        current_rows: '',
        current_pasted_minutes: '',


        deleteFormDataConfirmDialogVisible: false,

        shareDocDialogVisible: false,

        testQueryDialogVisible: false,
        qrcode_filename: '',

        emptyFormConfirmDialogVisible: false,

        editFormNameDialogVisible: false,
        selectedFormName: '',

        exportExcelDialogVisible: false,
        export_range: '',
        export_form_id: '',


        editFormCommentDialogVisible: false,
        selectedFormComment: ''


      }
    },
    mounted() {
      this.username = this.$session.get('USERNAME') // 获取session
      // this.loadSetting()
    },
    created() {
      console.log('调用exam_list created')
      this.username = this.$session.get('USERNAME') // 获取session
      // this.username = this.$route.params.username

      // this.username='1KuBxMrJiF4oWU5K2l0gv137dHrFKSy2'
      // this.loadDateList()
      this.loadData()
    },
    methods: {
      loadData() {
        console.log('加载数据')
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/evaluations/web/_load_send_list.jsp'
        this.axios.get(requestUrl, {
            params: {
              equipment: that.username
            }
          }).then(function(response) {
            that.tableData = response.data.form_list

            load.close()
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      makeFormList() {
        this.$router.push({
          name: 'make_form_list',
          params: {}
        })
      },

      deleteScoreForm(index, rows) {
        let that = this
        var form_id = rows[index].id
        this.$confirm('确定要删除此打分表吗?', '提示', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.deleteScoreFormAction(form_id)
        }).catch(() => {})
      },
      deleteScoreFormAction(form_id) {
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/evaluations/web/_delete_send_form.jsp'
        this.axios.get(requestUrl, {
            params: {
              form_id: form_id,
              equipment: that.username,
            }
          }).then(function(response) {
            that.loadData()

            load.close()


            that.$message.success('删除成功')
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },

      editScoreFormName(index, rows) {
        var old_name = rows[index].form_name
        console.log(old_name)
        this.edit_form_name_content = old_name
        this.selected_form_id = rows[index].id

        this.editFormNameDialogVisible = true
      },
      editFormNameSave() {
        if (Utils.isEmpty(this.edit_form_name_content)) {
          this.$message.error('名称不能为空！')
          return
        }

        let that = this

        var temp_form_id = this.selected_form_id

        // 调用删除接口
        var requestUrl = '/evaluations/web/_update_score_form_name.jsp'
        this.axios.get(requestUrl, {
            params: {
              form_id: temp_form_id,
              form_name: that.edit_form_name_content
            }
          }).then(function(response) {

            that.edit_form_name_content = ''
            that.editFormNameDialogVisible = false
            that.loadData()

            that.$message.success('修改成功！')
          })
          .catch(function(error) {
            console.log(error)
          })


      },
      editContactPhone(index, rows) {
        var old_phone = rows[index].contact_phone
        // console.log(old_phone)
        this.edit_contact_phone = old_phone
        this.selected_form_id = rows[index].id

        this.editContactPhoneDialogVisible = true
      },
      editContactPhoneSave() {

        let that = this

        var temp_form_id = this.selected_form_id

        // 调用删除接口
        var requestUrl = '/evaluations/web/_update_score_form_phone.jsp'
        this.axios.get(requestUrl, {
            params: {
              form_id: temp_form_id,
              contact_phone: that.edit_contact_phone
            }
          }).then(function(response) {

            that.edit_contact_phone = ''
            that.editContactPhoneDialogVisible = false
            that.loadData()

            that.$message.success('修改成功！')
          })
          .catch(function(error) {
            console.log(error)
          })
      },
      editFormComment(index, rows) {
        var form_comment = rows[index].form_comment
        // console.log(old_phone)
        this.edit_form_comment = form_comment
        this.selected_form_id = rows[index].id

        this.editFormCommentDialogVisible = true
      },
      editFormCommentSave() {
        let that = this

        var temp_form_id = this.selected_form_id

        // 调用删除接口
        var requestUrl = '/evaluations/web/_update_score_form_comment.jsp'
        this.axios.get(requestUrl, {
            params: {
              form_id: temp_form_id,
              form_comment: that.edit_form_comment
            }
          }).then(function(response) {

            that.edit_form_comment = ''
            that.editFormCommentDialogVisible = false
            that.loadData()

            that.$message.success('修改成功！')
          })
          .catch(function(error) {
            console.log(error)
          })
      },
      manageUser() {
        this.$alert('人员和指标修改请在手机上用“打分测评小程序”操作！')
      },







      // viewExam(index, rows) {
      //   // rows.splice(index, 1);

      //   var examID = rows[index].id
      //   // var course = rows[index].course
      //   var exam = rows[index].exam

      //   console.log('查看成绩单:' + exam)

      //   this.$router.push({
      //     name: 'exam_detail',
      //     params: {
      //       id: examID,
      //       // course: course,
      //       exam: exam
      //     }
      //   })
      // },
      // deleteForm(index, rows) {
      //   this.random_num = Utils.getRandomNum(4)
      //   this.selected_form_id = rows[index].id

      //   // this.deleteFormConfirmDialogVisible = true

      //   this.position = index
      //   this.selected_form_id = rows[index].id

      //   var state = rows[index].state

      //   if (state === 2) {
      //     this.$alert('《' + rows[index].form_name + '》正在填写,如要删除,请先收回表格！', '提示', {

      //       confirmButtonText: '确定',
      //       callback: action => {
      //         this.function()
      //       }
      //     })

      //     return
      //   }

      //   if (rows[index].submit_count > 0) {
      //     this.msg = '"' + rows[index].form_name + '"中有数据,删除后已经发放的查询将无法查询，且无法恢复！'
      //   } else {
      //     this.msg = '确定要删除《' + rows[index].form_name + '》吗?'
      //   }

      //   this.deleteFormConfirmDialogVisible = true

      //   // this.dialogVisible = true
      // },
      // emptyForm(index, rows) {
      //   this.random_num = Utils.getRandomNum(4)
      //   this.selected_form_id = rows[index].id

      //   // this.deleteFormConfirmDialogVisible = true


      //   if (rows[index].submit_count > 0) {
      //     this.msg = '"' + rows[index].form_name + '"中有数据,清空后已经发放的查询将无法查询，且无法恢复，但此表的二维码仍然有效！'
      //   } else {
      //     this.msg = '确定要清空《' + rows[index].form_name + '》吗?'
      //   }

      //   this.emptyFormConfirmDialogVisible = true

      //   // this.dialogVisible = true
      // },
      // deleteSelectedForm() {
      //   if (Utils.isEmpty(this.tmp_random_num)) {
      //     this.$message.error('请输入删除验证码!')
      //     return
      //   }

      //   if (this.tmp_random_num !== this.random_num) {
      //     this.$message.error('删除验证码不正确,请重新输入!')
      //   } else {

      //     this.delFormContentRecord()
      //   }

      //   //
      // },
      // delFormContentRecord() {
      //   let that = this
      //   this.deleteFormConfirmDialogVisible = false

      //   // 调用删除接口
      //   var requestUrl = '/evaluations/web/_delete_form_data_and_template.jsp'
      //   this.axios.get(requestUrl, {
      //       params: {
      //         form_id: that.selected_form_id,
      //         equipment: that.username
      //       }
      //     }).then(function(response) {
      //       that.tableData.splice(that.position, 1)
      //       // that.loadDateList()

      //       that.tmp_random_num = ''

      //       that.$message.success('删除成功！')
      //     })
      //     .catch(function(error) {
      //       console.log(error)
      //     })
      // },

      // emptySelectedForm() {
      //   if (Utils.isEmpty(this.tmp_random_num)) {
      //     this.$message.error('请输入清空验证码!')
      //     return
      //   }

      //   if (this.tmp_random_num !== this.random_num) {
      //     this.$message.error('清空验证码不正确,请重新输入!')
      //   } else {


      //     this.emptyFormContentRecord()
      //   }

      //   //
      // },
      // emptyFormContentRecord() {
      //   let that = this
      //   this.deleteFormConfirmDialogVisible = false

      //   // 调用删除接口
      //   var requestUrl = '/evaluations/web/_empty_query_data.jsp'
      //   this.axios.get(requestUrl, {
      //       params: {
      //         form_id: that.selected_form_id,
      //         equipment: that.username
      //       }
      //     }).then(function(response) {

      //       that.tmp_random_num = ''
      //       that.emptyFormConfirmDialogVisible = false

      //       that.$message.success('清除成功！')
      //       that.loadData()
      //     })
      //     .catch(function(error) {
      //       console.log(error)
      //     })
      // },
      // editFormName(index, rows) {
      //   this.position = index
      //   this.selected_form_id = rows[index].id
      //   this.selectedFormName = rows[index].form_name
      //   this.editFormNameDialogVisible = true
      // },
      // editFormComment(index, rows) {
      //   this.position = index
      //   this.selected_form_id = rows[index].id
      //   this.selectedFormName = rows[index].form_name
      //   this.selectedFormComment = rows[index].comment
      //   this.editFormCommentDialogVisible = true
      // },


      editExam(index, rows) {
        this.position = index
        this.selectedExamID = rows[index].id
        let that = this

        this.$router.push({
          name: 'exam_edit',
          params: {
            id: that.selectedExamID
          }
        })
      },
      importExcel() {
        // this.$router.push('/import_excel'),
        this.$router.push('/import_data_excel')
      },
      importMutiExcel() {
        this.$router.push('/exam_import_anyfile')
      },
      createNewExam() {
        this.$router.push('/exam_new')
      },

      indexMethods(index) {
        return this.tableData.length - index
      },
      viewUnSearchList(index, rows) {
        let that = this

        this.position = index
        this.selectedExamID = rows[index].id

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        // 注册接口
        var requestUrl = '/score/web/_get_students_score_list_unsearch.jsp'
        this.axios.get(requestUrl, {
            params: {
              id: that.selectedExamID
            }
          }).then(function(response) {
            that.students = response.data
            that.unReadDialogFormVisible = true

            load.close()
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      closeUnreadDialog() {
        this.unReadDialogFormVisible = false
      },
      filterExams(date) {
        console.log(date)
      },
      selectChanged() {
        console.log(this.filterCondition)
        this.loadData()
      },
      phoneShowSetting() {
        this.searchResultSettingDialogTableVisible = true
      },
      importedNextStep() {
        this.successDialogVisible = true
      },
      exportToFile(index, rows) {
        this.current_packed_time = rows[index].packed_finish_time
        this.current_pasted_minutes = rows[index].pasted_minutes

        this.current_index = index
        this.current_rows = rows

        if (this.current_packed_time !== '') {
          this.showExistZipDialog(index, rows)
        } else {
          this.export(index, rows)
        }

        // let that = this

        // // 开启loading
        // const load = this.$loading({
        //   lock: true,
        //   text: 'Loading',
        //   spinner: 'el-icon-loading',
        //   background: 'rgba(0, 0, 0, 0.7)'
        // })

        // var requestUrl = ''

        // var fileType = rows[index].file_type
        // if (fileType === 'EXCEL') {
        //   requestUrl = '/form/web/_export_to_excel.jsp'
        // } else if (fileType === 'ZIP') {
        //   requestUrl = '/form/web/_export_to_zip.jsp'
        // }

        // this.axios.get(requestUrl, {
        //   params: {
        //     username: that.username,
        //     form_id: formId
        //   }
        // }).then(function(response) {
        //   console.log(response)
        //   var fileName = ''
        //   if (fileType === 'EXCEL') {
        //     fileName = '/form/temp/' + formId + '.xls'
        //     that.downloadExcelDialogVisible = true
        //     that.current_download_file_name = fileName
        //   } else if (fileType === 'ZIP') {
        //     fileName = '/form/temp/' + formId + '.zip'
        //     that.downloadZipDialogVisible = true
        //     // that.current_download_file_name = fileName
        //     // that.current_download_file_name = response.data.download_file_path
        //     that.current_download_file_name = fileName

        //     that.zip_file_form_id = formId
        //   }

        //   load.close()
        // }).catch(function(error) {
        //   console.log(error)
        //   load.close()
        // })
      },
      showExistZipDialog(index, rows) {
        var selected_form_id = rows[this.current_index].id

        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/form/web/_load_export_zip_state.jsp'

        this.axios.get(requestUrl, {
          params: {
            form_id: selected_form_id
          }
        }).then(function(response) {
          console.log(response)
          // var fileName = ''


          that.downloadExistZipDialogVisible = true

          load.close()
        }).catch(function(error) {
          console.log(error)
          load.close()
        })
      },
      downloadExistZip() {
        this.downloadZipDialogVisible = false
        this.downloadExistZipDialogVisible = false

        var selected_form_id = this.current_rows[this.current_index].id

        var url = '/form/download.jsp?form_id=' + selected_form_id
        // window.open(this.current_download_file_name)
        window.open(url)
      },
      export (index, rows) {
        var formId = rows[index].id

        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = ''

        var fileType = rows[index].file_type
        if (fileType === 'EXCEL') {
          requestUrl = '/form/web/_export_to_excel.jsp'
        } else if (fileType === 'ZIP') {
          requestUrl = '/form/web/_export_to_zip.jsp'
        }

        this.axios.get(requestUrl, {
          params: {
            username: that.username,
            form_id: formId
          }
        }).then(function(response) {
          console.log(response)
          var fileName = ''
          if (fileType === 'EXCEL') {
            fileName = '/form/temp/' + formId + '.xls'
            that.downloadExcelDialogVisible = true
            that.current_download_file_name = fileName
          } else if (fileType === 'ZIP') {
            fileName = '/form/temp/' + formId + '.zip'
            that.downloadZipDialogVisible = true
            // that.current_download_file_name = fileName
            // that.current_download_file_name = response.data.download_file_path
            that.current_download_file_name = fileName

            that.zip_file_form_id = formId
          }

          load.close()
        }).catch(function(error) {
          console.log(error)
          load.close()
        })
      },
      exportToPDF(index, rows) {
        var formId = rows[index].id

        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/form/web/_export_to_pdf.jsp'

        this.axios.get(requestUrl, {
          params: {
            username: that.username,
            form_id: formId
          }
        }).then(function(response) {
          console.log(response)
          that.downloadPDFDialogVisible = true

          that.current_download_file_name = response.data.pdf_filename

          load.close()
        }).catch(function(error) {
          console.log(error)
          load.close()
        })
      },
      createNewForm() {},
      downloadExcel() {
        this.downloadExcelDialogVisible = false
        window.open(this.current_download_file_name)
      },
      downloadNewZip() {
        this.downloadZipDialogVisible = false
        this.downloadExistZipDialogVisible = false

        let that = this
        var formId = that.current_rows[that.current_index].id

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        var requestUrl = ''
        requestUrl = '/form/web/_export_to_zip.jsp'
        this.axios.get(requestUrl, {
          params: {
            username: that.username,
            form_id: formId
          }
        }).then(function(response) {
          console.log(response)

          load.close()
          var fileName = ''
          fileName = '/form/temp/' + formId + '.zip'
          that.current_download_file_name = fileName
          var selected_form_id = that.current_rows[that.current_index].id
          var url = '/form/download.jsp?form_id=' + selected_form_id
          // window.open(this.current_download_file_name)
          window.open(url)
        }).catch(function(error) {
          console.log(error)
          load.close()
        })
      },

      sendForm(index, rows) {
        this.selected_form_name = rows[index].form_name
        this.selected_form_id = rows[index].id


        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        // 调用删除接口
        var requestUrl = "/evaluations/phone/qrcode_generator.jsp?form_id=" + this.selected_form_id
        console.log('requestUrl =', requestUrl)

        this.axios.get(requestUrl, {
            params: {
              form_id: that.selected_form_id,
              equipment: that.username
            }
          }).then(function(response) {

            that.qrcode_filename = '/evaluations' + response.data.file_name
            // console.log('>>>>>>>>>>>>>>>>',that.qrcode_filename)

            that.sendFormDialogVisible = true

            load.close()
          })
          .catch(function(error) {
            console.log(error)

            load.close()
          })


      },
      browseData(index, rows) {
        // var formId = rows[index].id
        // var url = '/form/web/_browse_form_data.jsp?form_id=' + formId
        // window.open(url)

        var formId = rows[index].id
        var formName = rows[index].form_name

        this.$router.push({
          name: 'browse_all_data',
          params: {
            form_id: formId,
            form_name: formName
          }
        })
      },
      exportData(index, rows) {
          this.export_form_id = rows[index].id
          this.selected_form = rows[index]


        if (this.selected_form.form_type == '110') {
          this.$alert('开放式多人表导出时需要消耗大量时间，电脑端暂时无法显示导出进度，请用手机端小程序操作。手机端不但可查看导出进度，还可以重新导出。', '操作提醒', {
            confirmButtonText: '知道了',
            callback: action => {}
          });
        } else {



          this.exportExcelDialogVisible = true
        }


      },
      exportDataAction() {


        let that = this

        // 调用删除接口
        var requestUrl = ''


        if (this.selected_form.form_type == '10') {
          requestUrl = '/evaluations/web/_export_self_single_quota_excel.jsp'
        } else if (this.selected_form.form_type == '20') {
          requestUrl = '/evaluations/web/_export_single_quota_excel.jsp'
        } else if (this.selected_form.form_type == '50') {
          requestUrl = '/evaluations/web/_export_self_single_quota_excel_ex.jsp'
        } else if (this.selected_form.form_type == '60') {
          requestUrl = '/evaluations/web/_export_single_quota_excel_ex_muti.jsp'
        } else if (this.selected_form.form_type == '100') {
          requestUrl = '/evaluations/web/_export_satisfy_form_excel.jsp'
        } else if (this.selected_form.form_type == '110') {
          requestUrl = '/evaluations/web/_export_satisfy_form_excel_ex.jsp'
        }

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        this.axios.get(requestUrl, {
            params: {
              form_id: that.export_form_id,
            }
          }).then(function(response) {

            that.export_form_id = ''
            that.export_range = ''

            console.log(response)

            that.current_download_file_name = '/evaluations' + response.data.file_url

            that.exportExcelDialogVisible = false
            that.downloadExcelDialogVisible = true
            // that.downloadExcel()

            load.close()

          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },

      openMakeForm() {
        this.$router.push('/make_form')
      },
      validCondition(index, rows) {
        var formId = rows[index].id
        var formName = rows[index].form_name

        // console.log(rows[index])
        // console.log(formId)
        // console.log(formName)

        this.$router.push({
          name: 'set_valid_condition',
          params: {
            form_id: formId,
            form_name: formName
          }
        })
      },
      whatIsNextStep() {
        this.howToNextStepDialogVisible = true
      },
      collectAdvice(index, rows) {
        // this.$message.info('adsfadf')
      },
      howToUseInviteForm() {
        this.howToUseInviteFormDialogVisible = true
      },
      emptyFormData(index, rows) {
        this.random_num = Utils.getRandomNum(4)
        this.tmp_random_num = ''
        this.msg = '要清空《' + rows[index].form_name + '》的全部数据吗?'
        this.selected_form_id = rows[index].id
        this.deleteFormDataConfirmDialogVisible = true
      },
      emptySelectedFormData() {
        let that = this

        if (Utils.isEmpty(this.tmp_random_num)) {
          this.$message.error('请输入清空数据验证码!')
          return
        }

        if (this.tmp_random_num !== this.random_num) {
          this.$message.error('清空数据验证码不正确,请重新输入!')
          return
        }

        // 调用删除接口
        var requestUrl = '/form/web/_empty_form_data.jsp'
        console.log('requestUrl =', requestUrl)

        this.axios.get(requestUrl, {
            params: {
              form_id: that.selected_form_id,
              equipment: that.username
            }
          }).then(function(response) {
            that.deleteFormDataConfirmDialogVisible = false
            that.tmp_random_num = ''
            // that.tableData.splice(that.position, 1)
            that.loadData()

            that.$message.success('清空成功！')
          })
          .catch(function(error) {
            console.log(error)
          })
      },
      showShareDocDialog() {
        this.shareDocDialogVisible = true
      },
      getSearchedPercent(total, searched_count) {
        var percent = 0;

        if (total == 0) {
          percent = 0
        } else {
          // if(Utils.isEmpty(searched_count)){
          // 	searched_count=1
          // }
          percent = ((searched_count / total) * 100)
        }

        return percent.toFixed(1)
      },
      resetQueryConditions(index, rows) {
        this.selected_form_name = rows[index].form_name
        this.selected_form_id = rows[index].id

        this.$router.push({
          name: 'reset_query_conditions',
          params: {
            form_id: this.selected_form_id,
            form_name: this.selected_form_name
          }
        })
      },
      testQuery(index, rows) {
        this.selected_form_name = rows[index].form_name
        this.selected_form_id = rows[index].id

        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        // 调用删除接口
        var requestUrl = "/evaluations/phone/qrcode_generator.jsp?form_id=" + this.selected_form_id
        console.log('requestUrl =', requestUrl)

        this.axios.get(requestUrl, {
            params: {
              form_id: that.selected_form_id,
              equipment: that.username
            }
          }).then(function(response) {

            that.qrcode_filename = '/evaluations' + response.data.file_name
            // console.log('>>>>>>>>>>>>>>>>',that.qrcode_filename)

            that.testQueryDialogVisible = true

            load.close()
          })
          .catch(function(error) {
            console.log(error)

            load.close()
          })


      },
      copyDownloadUrl() {

        var urlstr = window.location.origin + this.current_download_file_name

        this.$copyText(urlstr).then(message => {

          this.$message('下载网址复制成功')


        }).catch(err => {

          this.$message('下载网址复制失败')

        })

      }
    },
    watch: {
      $route() {
        this.loadData()
      }
    }
  }
</script>

<style>
  .actionStyle {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

  }

  :header-cell-style: {
    background: '#E9EEF5';
    color: '#000'
  }

  .actionBarStyle {
    display: flex;
    justify-content: space-between;
  }

  .rowStyle {
    display: flex;
    justify-content: space-between;
  }

  .settingGroupStyle {
    display: flex;
    flex-direction: column;
  }

  .rowBtnStyle {
    display: flex;
    justify-content: flex-end;
    padding-top: 50upx;
  }

  .dateRowStyle {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .imgItemStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .imageStyle {
    display: flex;
    justify-content: center;

  }
</style>



// WEBPACK FOOTER //
// src/components/form_list.vue